export const CustomSelectStyle = {
  control: (base, state) => {
    const isDark = document.documentElement.classList.contains("dark");

    return {
      ...base,
      backgroundColor: isDark ? "#111827" : "white",
      borderColor: state.isFocused
        ? "#f97316"
        : isDark
        ? "#374151"
        : "#e5e7eb",
      boxShadow: state.isFocused ? "0 0 0 1px #f97316" : "none",
      "&:hover": {
        borderColor: "#f97316",
      },
      borderRadius: "0.5rem",
      minHeight: "42px",
      fontSize: "0.95rem",
      padding: "2px 4px",
      color: isDark ? "white" : "#111827",
    };
  },

  menu: (base) => {
    const isDark = document.documentElement.classList.contains("dark");

    return {
      ...base,
      backgroundColor: isDark ? "#1f2937" : "white",
      borderRadius: "0.5rem",
      overflow: "hidden",
    };
  },

  option: (base, state) => {
    const isDark = document.documentElement.classList.contains("dark");

    return {
      ...base,
      backgroundColor: state.isSelected
        ? "#f97316"
        : state.isFocused
        ? isDark
          ? "#374151"
          : "#fff7ed"
        : isDark
        ? "#1f2937"
        : "white",

      color: state.isSelected
        ? "white"
        : isDark
        ? "#e5e7eb"
        : "#111827",

      cursor: "pointer",
    };
  },

  singleValue: (base) => {
    const isDark = document.documentElement.classList.contains("dark");

    return {
      ...base,
      color: isDark ? "#e5e7eb" : "#111827",
    };
  },

  input: (base) => {
    const isDark = document.documentElement.classList.contains("dark");

    return {
      ...base,
      color: isDark ? "#e5e7eb" : "#111827",
    };
  },
};


